"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconHighlight = Experimental__IconHighlight;
exports.IconHighlight = IconHighlight;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * @deprecated IconHighlight is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function IconHighlight(props) {
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M12.222 2.5h.056c.397.333.97.5 1.722.5.519 0 .971-.09 1.357-.27l-1.5 8.254.42.468L16 2c0-.275-.196-.51-.587-.706C15.021 1.098 14.55 1 14 1s-1.021.098-1.413.294c-.391.195-.587.43-.587.706L8.841 5.468l.342.373 3.04-3.341h-.001zm-7.016 7.714l2.286-2.516-.333-.373-2.77 3.048c.175-.042.447-.095.817-.159zm-3.023 1L.643 2.73C1.03 2.91 1.482 3 2 3c.751 0 1.325-.167 1.722-.5h.056l7.016 7.714c.37.064.642.117.817.159L4 2c0-.275-.196-.51-.587-.706C3.021 1.098 2.55 1 2 1s-1.021.098-1.413.294C.196 1.489 0 1.724 0 2l1.738 9.548a2.99 2.99 0 01.445-.334zM2 13c0 .36.267.693.802 1 .534.307 1.261.55 2.182.73.92.18 1.926.27 3.016.27s2.095-.09 3.016-.27c.92-.18 1.647-.423 2.182-.73.535-.307.802-.64.802-1s-.267-.693-.802-1c-.534-.307-1.261-.55-2.182-.73C10.096 11.09 9.09 11 8 11s-2.095.09-3.016.27c-.92.18-1.647.423-2.182.73-.535.307-.802.64-.802 1z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M17.277 5.125h.07c.496.417 1.214.625 2.153.625.648 0 1.214-.112 1.696-.338L19.321 15.73l.525.585L22 4.5c0-.344-.245-.638-.734-.882-.49-.245-1.078-.368-1.766-.368s-1.276.123-1.766.368c-.49.244-.734.538-.734.882l-3.949 4.335.428.466 3.8-4.176h-.002zm-8.77 9.643l2.858-3.146-.416-.466-3.463 3.81c.219-.052.559-.118 1.022-.198zm-3.778 1.25L2.804 5.411c.483.226 1.049.338 1.696.338.94 0 1.657-.208 2.152-.625h.07l8.77 9.643c.463.08.803.146 1.022.198L7 4.5c0-.344-.245-.638-.734-.882-.49-.245-1.079-.368-1.766-.368-.688 0-1.276.123-1.766.368-.49.244-.734.538-.734.882l2.173 11.935c.184-.166.37-.305.556-.418zM4.5 18.25c0 .45.334.867 1.003 1.25.667.383 1.576.688 2.727.913 1.15.224 2.407.337 3.77.337s2.62-.113 3.77-.337c1.15-.226 2.06-.53 2.727-.913.669-.383 1.003-.8 1.003-1.25 0-.45-.334-.867-1.003-1.25-.667-.383-1.576-.688-2.727-.913-1.15-.224-2.407-.337-3.77-.337s-2.62.113-3.77.337c-1.15.226-2.06.53-2.728.913-.668.383-1.002.8-1.002 1.25z\'/>'
  }];
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = props.autoMirror || false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated IconHighlight is deprecated and will be archived soon. To find a suitable alternative, refer to https://encore.spotify.net/foundation/basics/icons?format=web-js#browse-icons.
 */
function Experimental__IconHighlight(props) {
  return /*#__PURE__*/_react["default"].createElement(IconHighlight, props);
}